(() => {
  const TRIGGER_SELECTOR =
    '[data-lm-quick-add-trigger]';

  function findOriginalButton(trigger) {
    const targetId =
      trigger.dataset.lmQuickAddTarget;

    if (!targetId) {
      return null;
    }

    const productCard = trigger.closest(
      '.product-card-wrapper'
    );

    if (!productCard) {
      return null;
    }

    return productCard.querySelector(
      `#${CSS.escape(targetId)}`
    );
  }

  function handleQuickAddClick(event) {
    const trigger = event.target.closest(
      TRIGGER_SELECTOR
    );

    if (!trigger) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (trigger.disabled) {
      return;
    }

    const originalButton =
      findOriginalButton(trigger);

    if (!originalButton) {
      console.warn(
        'Lil Miracle Quick Add: Der ursprüngliche Shopify-Button wurde nicht gefunden.',
        trigger.dataset.lmQuickAddTarget
      );

      return;
    }

    if (originalButton.disabled) {
      return;
    }

    /*
     * Der Originalbutton bleibt für Shopify der
     * eigentliche Funktionsauslöser.
     *
     * Eine Variante:
     * Das vorhandene product-form wird abgesendet.
     *
     * Mehrere Varianten:
     * Der vorhandene modal-opener öffnet das
     * Shopify-Quick-Add-Fenster.
     */
    originalButton.click();
  }

  document.addEventListener(
    'click',
    handleQuickAddClick
  );
})();